var exports = {
  "kR": "x28a7bf27--0075b2--cards",
  "Nr": "x28a7bf27--0075b2--card",
  "_8": "x28a7bf27--0075b2--img",
  "Qs": "x28a7bf27--0075b2--content",
  "DD": "x28a7bf27--0075b2--title",
};

module.exports = exports;
